import { IconProp } from "@fortawesome/fontawesome-svg-core";
import React from "react";
import styled, { CSSProperties } from "styled-components";

import { Rounded } from "../theme/Rounded";
import { Spacing } from "../theme/Spacing";
import { ThemeType } from "../theme/Theme";
import { AtiraIcon } from "./AtiraIcon";
import { Flex } from "./Flex";
import { FontSize, Text } from "./Text";
import { faInfo } from "@fortawesome/free-solid-svg-icons/faInfo";

const Container = styled(Flex)<{ color?: keyof ThemeType }>`
  gap: ${Spacing.m};
  padding: ${Spacing.s} ${Spacing.m};
  border-radius: ${Rounded.md};
  position: relative;
  z-index: 1;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme, color }) => theme[color || "main"]};
    opacity: 0.1;
    border-radius: inherit;
    z-index: -1;
  }
`;

type InfoProps = {
  info: string | React.ReactNode;
  icon?: IconProp;
  color?: keyof ThemeType;
  align?: CSSProperties["alignItems"];
  width?: CSSProperties["width"];
  size?: keyof typeof FontSize;
};

export const Info: React.FC<InfoProps> = ({
  info,
  color = "main",
  icon = faInfo,
  align,
  width,
  size = "s",
}) => {
  return (
    <Container color={color} alignItems={align || "center"} width={width}>
      <AtiraIcon icon={icon} color={color} size="lg" />

      <Text fontSize={size} color={color}>
        {info}
      </Text>
    </Container>
  );
};
